import React from 'react';
import './style.scss';
function primaryButton({ children, ...rest }) {
	return (
		<button {...rest} className="primary-button">
			{children}
		</button>
	);
}
export default primaryButton;
